function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 4v13c-1 0-2-1-2-2V6C8 6 7 5 7 4s1-2 2-2 2 1 2 2zm5 4c2 2 3 4 3 6 0 4-3 7-7 7s-7-3-7-7c0-2 1-4 3-6v3c-1 1-1 2-1 3 0 3 2 5 5 5s5-2 5-5c0-1 0-2-1-3V8zm-3 9V6c0-1 1-2 2-2s2 1 2 2-1 2-2 2v7c0 1-1 2-2 2z",
  fill: "currentColor"
});

function SvgLocationSpring(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSpring);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBzdHlsZT0iZmlsbDpub25lIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xMSA0TDExIDE0IDExIDE3QzEwIDE3IDkgMTYgOSAxNUw5IDZDOCA2IDcgNSA3IDQgNyAzIDggMiA5IDIgMTAgMiAxMSAzIDExIDRaTTE2IDhDMTggMTAgMTkgMTIgMTkgMTQgMTkgMTggMTYgMjEgMTIgMjEgOCAyMSA1IDE4IDUgMTQgNSAxMiA2IDEwIDggOEw4IDExQzcgMTIgNyAxMyA3IDE0IDcgMTcgOSAxOSAxMiAxOSAxNSAxOSAxNyAxNyAxNyAxNCAxNyAxMyAxNyAxMiAxNiAxMUwxNiA4Wk0xMyAxN0wxMyA2QzEzIDUgMTQgNCAxNSA0IDE2IDQgMTcgNSAxNyA2IDE3IDcgMTYgOCAxNSA4TDE1IDE1QzE1IDE2IDE0IDE3IDEzIDE3WiIvPjwvZz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };